module.exports = __webpack_public_path__ + "static/media/vasko@2x.5c7ded2c.png";